<template>
  <div class="user-main">
    <div class="user-main-head">
      <img data-track-text="返回订单详情" @click="clickHandler('/order')" style="margin-left: 28px" src="../assets/go-back.png" alt=""/>
      <div>发票申请</div>
    </div>
    <div class="main-login-form">
      <div class="main-login-form-input">
        <el-form label-width="0" class="demo-ruleForm" :model="form" :rules="updatePassFormRules" ref="updatePassForm">
          <el-form-item prop="company">
            <el-input placeholder="单位名称：" v-model="form.company"></el-input>
          </el-form-item>
          <el-form-item prop="companyCode">
            <el-input placeholder="单位税号：" v-model="form.companyCode"></el-input>
          </el-form-item>
          <el-form-item prop="content" class="radio-content">
            <el-radio v-model="form.content" label="TECH_SVC">信息技术服务*技术服务费</el-radio>
            <el-radio v-model="form.content" label="TRANS_SVC">信息技术服务*翻译服务费</el-radio>
            <el-radio v-model="form.content" label="AUDIT_SVC">信息技术服务*审校费</el-radio>
            <el-radio v-model="form.content" label="OTHER_SVC">如需其他，请添加QQ1077258421，进行沟通</el-radio>
          </el-form-item>
          <el-form-item class="login_button">
            <el-button type="primary" data-track-text="提交发票申请" :data-track-business-id="item.batchId" @click="submit()">申请发票</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import {redirectToMainLogin} from '@/utils/responsive'

export default {
  name: "ApplyBill",
  data() {
    return {
      item: {},
      form: {
        company: '',
        companyCode: '',
        content: '',
        batchId: []
      },
      formLabelWidth: '100px',
      updatePassFormRules: {
        company: [
          {required: true, message: '请输入单位名称', trigger: 'blur'},
          {min: 1, max: 200, message: '长度在 1 到 200 个字符', trigger: 'blur'}
        ],
        companyCode: [
          {required: true, message: '请输入单位税号', trigger: 'blur'},
          {min: 1, max: 200, message: '长度在 1 到 200 个字符', trigger: 'blur'}
        ],
        content: [
          {required: true, message: '请选择开票内容', trigger: 'change'},
        ]
      },
    }
  },
  mounted() {
    this.item = this.$route.params
    this.form.batchId.push(this.item.batchId)
  },
  methods: {
    submit() {
      this.$track('invoice_apply_submit', {selectedCount: this.form.batchId.length, source: 'apply_page'})
      this.$refs.updatePassForm.validate((valid) => {
        if (!valid) {
          this.$track('invoice_apply_result', {result: 'validation_failed', selectedCount: this.form.batchId.length, source: 'apply_page'})
          return;
        }
        this.$http.get("/api/account/applyBill?batchIds=" + this.form.batchId.join(',') +
          "&company=" + this.form.company + "&companyCode=" + this.form.companyCode +
          "&content=" + this.form.content).then(res => {
          if (res.data) {
            if (res.data === 'ok') {
              this.$track('invoice_apply_result', {result: 'success', selectedCount: this.form.batchId.length, source: 'apply_page'})
              this.item.status = 24
              this.$router.push({
                name: "DDdetail",
                params: this.item
              });
              return
            }
            if (res.data === 'need_login') {
              this.$track('invoice_apply_result', {result: 'failure', reason: 'need_login', selectedCount: this.form.batchId.length, source: 'apply_page'})
              setTimeout(redirectToMainLogin, 3000)
              return;
            }
            this.$track('invoice_apply_result', {result: 'failure', reason: 'business_rejected', selectedCount: this.form.batchId.length, source: 'apply_page'})
            this.messages = res.data
          }
        }).catch(err => {
          this.$track('invoice_apply_result', {result: 'failure', reason: 'request_failed', selectedCount: this.form.batchId.length, source: 'apply_page'})
          this.messages = "操作异常，请稍后再试"
        })
      })
    },
    clickHandler(url) {
      this.$router.push({
        name: "DDdetail",
        params: this.item
      });
    },
  }
}
</script>

<style lang="less" scoped>
.timeButton {
  border-radius: 3px;
  cursor: pointer;
  white-space: nowrap;
  padding: 10px 20px;
  border: 0px solid #000;
  width: 94px;
  height: 45px;
  float: right;
  background-color: #efeded;
  font-size: 21px;
  font-weight: 400;
  font-family: Noto Sans S Chinese !important;
  color: #333333;
  display: flex;
  justify-content: center;
}

.timeButtonClick {
  border-radius: 3px;
  cursor: pointer;
  white-space: nowrap;
  padding: 10px 20px;
  border: 0px solid #000;
  width: 94px;
  height: 45px;
  float: right;
  background-color: #0c7dba;
  font-size: 18px;
  font-weight: 400;
  font-family: Noto Sans S Chinese !important;
  display: flex;
  justify-content: center;
  color: #ffffff;
}

.main-login-form {
  width: 704px;
  height: 1000px;
  background: #FFFFFF;
  margin-top: 30px;
  margin-bottom: 30px;

  .main-login-form-input {
    padding-top: 50px;
    width: 625px;
    display: flex;
    justify-content: center;

    /deep/ .demo-ruleForm {
      .el-form-item.is-error .el-input__inner, .el-form-item.is-error .el-input__inner:focus, .el-form-item.is-error .el-textarea__inner, .el-form-item.is-error .el-textarea__inner:focus {
        height: 65px;
        border: 1px solid #FBAFAF;
        box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.05);
        border-radius: 3px;
      }

      .el-button--primary {
        width: 624px;
        height: 70px;
        background: #063f95;
        border-radius: 3px;
        margin-top: 31px;
        font-size: 30px;
        font-family: Adobe Heiti Std;
        font-weight: normal;
        color: #FFFFFF;
      }

      .el-form-item__error {
        color: #F56C6C;
        font-size: 20px;
        line-height: 1;
        padding-top: 4px;
        position: absolute;
        top: 100%;
        left: 0;
      }

      .el-form-item {
        margin-bottom: 31px;
      }

      .el-form-item__content {
        margin-left: 76px !important;
      }

      .el-input {
        height: 65px;
        width: 625px;

        .el-input__inner {
          height: 65px;
          border: 1px solid #DDDDDD;
          box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.05);
          border-radius: 3px;
          font-size: 24px;
        }
      }

      .radio-content {
        .el-form-item__content {
          display: flex;
          flex-flow: column;
          align-items: flex-start;
          justify-content: space-between;
          height: 170px;

          .el-radio {
            .el-radio__inner {
              width: 24px;
              height: 24px;
            }

            .el-radio__label {
              font-size: 24px;
            }
          }
        }
      }
    }
  }
}

.user-main {
  min-width: 765px;
  width: 100%;
  background: #f5f5f5;
  display: flex;
  flex-flow: column;
  align-items: center;
  overflow-x: hidden;
}

.user-main-head {
  width: 100%;
  height: 88px;
  background: #E6E6E6;
  display: flex;
  align-items: center;
}

.user-main-head div {
  flex: 1;
  font-size: 24px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
  text-align: center;
  margin-right: 60px;
}

@media (max-width: 768px) {
  .user-main {
    min-width: 0;
    width: 100%;
    max-width: 100vw;
    overflow-x: hidden;
    box-sizing: border-box;
  }

  .user-main-head {
    width: 100%;
    height: 56px;
    padding: 0 12px;
    box-sizing: border-box;
  }

  .user-main-head > img {
    width: 20px;
    height: 20px;
    margin-left: 0 !important;
    object-fit: contain;
  }

  .user-main-head div {
    margin-right: 20px;
    font-size: 17px;
  }

  .main-login-form {
    width: calc(100% - 24px);
    max-width: 100%;
    height: auto;
    min-height: calc(100vh - 92px);
    margin: 12px;
    padding: 28px 16px 96px;
    box-sizing: border-box;

    .main-login-form-input {
      width: 100%;
      max-width: 100%;
      min-width: 0;
      padding-top: 0;
      display: block;
      box-sizing: border-box;
    }
  }

  .main-login-form .main-login-form-input /deep/ .demo-ruleForm,
  .main-login-form .main-login-form-input /deep/ .demo-ruleForm .el-form-item,
  .main-login-form .main-login-form-input /deep/ .demo-ruleForm .el-form-item__content,
  .main-login-form .main-login-form-input /deep/ .demo-ruleForm .el-input,
  .main-login-form .main-login-form-input /deep/ .demo-ruleForm .el-input__inner {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
    box-sizing: border-box;
  }

  .main-login-form .main-login-form-input /deep/ .demo-ruleForm .el-form-item {
    margin-bottom: 22px;
  }

  .main-login-form .main-login-form-input /deep/ .demo-ruleForm .el-form-item__content {
    margin-left: 0 !important;
  }

  .main-login-form .main-login-form-input /deep/ .demo-ruleForm .el-input,
  .main-login-form .main-login-form-input /deep/ .demo-ruleForm .el-input__inner,
  .main-login-form .main-login-form-input /deep/ .demo-ruleForm .el-form-item.is-error .el-input__inner {
    height: 44px !important;
  }

  .main-login-form .main-login-form-input /deep/ .demo-ruleForm .el-input__inner {
    font-size: 15px;
  }

  .main-login-form .main-login-form-input /deep/ .demo-ruleForm .radio-content .el-form-item__content {
    height: auto;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }

  .main-login-form .main-login-form-input /deep/ .demo-ruleForm .radio-content .el-radio {
    display: flex;
    align-items: flex-start;
    width: 100%;
    margin: 0;
    white-space: normal;
  }

  .main-login-form .main-login-form-input /deep/ .demo-ruleForm .radio-content .el-radio__inner {
    width: 16px;
    height: 16px;
  }

  .main-login-form .main-login-form-input /deep/ .demo-ruleForm .radio-content .el-radio__label {
    min-width: 0;
    padding-left: 8px;
    font-size: 14px;
    line-height: 20px;
    white-space: normal;
    overflow-wrap: anywhere;
  }

  .main-login-form .main-login-form-input /deep/ .demo-ruleForm .el-form-item__error {
    font-size: 12px;
    line-height: 16px;
  }

  .main-login-form .main-login-form-input /deep/ .demo-ruleForm .el-button--primary {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
    height: 44px !important;
    margin-top: 10px;
    box-sizing: border-box;
    font-size: 16px;
  }
}
</style>
